import LockTableMouseEventsHandlerState from "./LockTableMouseEventsHandlerState";

export default class IgnoreMouseEventsState extends LockTableMouseEventsHandlerState{
    constructor(mouseEventsHandler) {
        super(mouseEventsHandler);
        this.lastHoveredCell = null;
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/IgnoreMouseEventsState.js